import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TemplateVariableService {
  
  /**
   * Replace template variables in HTML content
   */
  replaceTemplateVariables(htmlContent: string): string {
    let processedHtml = htmlContent;
    
    // Replace {{TEMPLATE_IMAGE_BASE_URL}} with actual base URL
    processedHtml = processedHtml.replace(
      /\{\{TEMPLATE_IMAGE_BASE_URL\}\}/g, 
      environment.templateImageBaseUrl
    );
    
    return processedHtml;
  }
  
  /**
   * Get the base URL for template images
   */
  getTemplateImageBaseUrl(): string {
    return environment.templateImageBaseUrl;
  }
}
